<template>
    <div class="container d-flex justify-content-evenly" style="padding-top: 100px;">
      <Card class="d-flex flex-column">
        <template #title>
          Upload Country
        </template>
        <template #content>
          <div class="d-flex">
            <a href="https://docs.google.com/spreadsheets/d/1PU2IgKvRNmveniQ27gchSfEHyQn80wlXhsDzEhtczkE/edit?gid=0#gid=0" download="Ornek_Excel.xlsx" target="_blank">
              <button class="p-button p-component p-button-info d-inline me-2" style="border-radius: 0.5em;">Sample Excel</button>
            </a>
            <FileUpload
                mode="basic"
                class="ms-2"
                name="file[]"
                accept=".xlsx"
                :file-limit="1"
                :customUpload="true"
                @uploader="(event) => uploader(event, 'country')"
                :maxFileSize="5000000"
                choose-label="Upload"
                upload-label="Upload"
                cancel-label="Cancel"
            />
          </div>
        </template>
      </Card>
      <Card class="d-flex flex-column">
        <template #title>
          Upload City
        </template>
        <template #content>
          <div class="d-flex">
            <a href="https://docs.google.com/spreadsheets/d/1699a8Z6SAgrhCqHVTnH8-WzAGc4Jj1ADmcqPGk0V3qo/edit?gid=0#gid=0" download="Ornek_Excel.xlsx" target="_blank">
              <button class="p-button p-component p-button-info d-inline me-2"  style="border-radius: 0.5em;">Sample Excel</button>
            </a>
            <FileUpload
                mode="basic"
                class="ms-2"
                name="file[]"
                accept=".xlsx"
                :file-limit="1"
                :customUpload="true"
                @uploader="(event) => uploader(event, 'city')"
                :maxFileSize="5000000"
                choose-label="Upload"
                upload-label="Upload"
                cancel-label="Cancel"
            />
          </div>
        </template>
      </Card>
      <Card class="d-flex flex-column">
        <template #title>
          Upload District
        </template>
        <template #content>
          <div class="d-flex">
            <a href="https://docs.google.com/spreadsheets/d/1G9iZgRolzyHskoXGmY8F2dbJI0tOW6nm8RKk6fIRya0/edit?gid=0#gid=0" download="Ornek_Excel.xlsx" target="_blank">
              <button class="p-button p-component p-button-info d-inline me-2" style="border-radius: 0.5em;">Sample Excel</button>
            </a>
            <FileUpload
                mode="basic"
                class="ms-2"
                name="file[]"
                accept=".xlsx"
                :file-limit="1"
                :customUpload="true"
                @uploader="(event) => uploader(event, 'district')"
                :maxFileSize="5000000"
                choose-label="Upload"
                upload-label="Upload"
                cancel-label="Cancel"
            />
          </div>
        </template>
      </Card>
    </div>
</template>

<script>
import Card from "primevue/card";

export default {
  components: {Card},
  data(){
    return {

    }
  },
  methods:{
    uploader(event, type) {
      const file = event.files[0];
      let formData = new FormData();
      formData.append("file", file);

      let endpoint = '';
      switch (type) {
        case 'country':
          endpoint = "admin/location/add-country-excel";
          break;
        case 'city':
          endpoint = "admin/location/add-city-excel";
          break;
        case 'district':
          endpoint = "admin/location/add-district-excel";
          break;
        default:
          return;
      }
      this.$appAxios
          .post(endpoint, formData)
          .then(() => {
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: `${type.charAt(0).toUpperCase() + type.slice(1)} file was uploaded successfully`,
              life: 3000
            });
            this.$swal.fire({
              text: "Dosya başarıyla yüklendi ve veriler eklendi.",
              icon: "success",
              customClass: {
                container: "my-sweet",
              },
              confirmButtonText: this.$t("global.ok"),
            });
          })
          .catch(() => {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: `Could not upload the ${type} file`,
              life: 3000
            });
          });
    }
  }
}
</script>